import {Col, Row} from "react-bootstrap";
import PropTypes from "prop-types";

export function DayElement(props) {
    const {title, children, today, className, small, hasTask} = props;

    return <Col xs={12}>
        <div style={{minHeight: small ? "auto" : "75px"}} className={className}>

            <p style={{wordBreak:"keep-all",margin:"0"}} className={`${today ? `bg-primary rounded-5 ${hasTask ? 'text-warning' : 'text-white'}` : `${hasTask ? 'text-warning' : 'text-black'}`} `}>{title}</p>

            <div>
                {children}
            </div>
        </div>
    </Col>
}

DayElement.propTypes = {
    title: PropTypes.string,
    children: PropTypes.any,
    style: PropTypes.shape({}),
    today: PropTypes.bool,
    className: PropTypes.string
};
